var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home",class:_vm.sections.array[_vm.sections.counter].clase},[_c('transition',{attrs:{"name":_vm.sectionAnim,"mode":"out-in"}},[_c(_vm.sections.array[_vm.sections.counter].name,{tag:"component"})],1),_c('switcher')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }